var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCircle24Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 2.0007C17.5236 2.0007 22.0007 6.47786 22.0007 12.0007C22.0007 17.5236 17.5236 22.0007 12.0007 22.0007C6.47788 22.0007 2.00073 17.5236 2.00073 12.0007C2.00073 6.47786 6.47788 2.0007 12.0007 2.0007ZM12.7811 7.46967L12.6969 7.39705C12.436 7.2034 12.0777 7.20101 11.8144 7.38988L11.7204 7.46967L11.6478 7.55379C11.4541 7.81478 11.4517 8.17299 11.6406 8.43638L11.7204 8.53033L14.44 11.25H7.75003L7.64826 11.2568C7.31546 11.302 7.05202 11.5654 7.00688 11.8982L7.00003 12L7.00688 12.1018C7.05202 12.4346 7.31546 12.698 7.64826 12.7432L7.75003 12.75H14.44L11.7198 15.4704L11.6472 15.5545C11.4293 15.8481 11.4534 16.2647 11.7196 16.5311C11.9858 16.7974 12.4025 16.8217 12.6961 16.6039L12.7803 16.5313L16.7818 12.5313L16.8544 12.4471C17.0481 12.1862 17.0506 11.8279 16.8617 11.5645L16.7819 11.4705L12.7811 7.46967L12.6969 7.39705L12.7811 7.46967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle24Filled);
export default __webpack_public_path__ + "static/media/ArrowRightCircle-24-Filled.7efda7a806542ef8976df9ba53c889cf.svg";
export { ForwardRef as ReactComponent };